import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { GET_PERMIT_BLUEPRINTS } from "../queries/getPermitBlueprints";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";

const ADD_PERMIT_BLUEPRINT = gql`
  ${PERMIT_TEMPLATE_FIELDS}
  mutation AddPermitBlueprint($name: String!, $templateJson: String) {
    addPermitBlueprint(input: { name: $name, templateJson: $templateJson }) {
      blueprint {
        id
        key
        name
        template {
          ...PermitTemplateFields
        }
      }
    }
  }
`;

export function useAddPermitBlueprint() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation(ADD_PERMIT_BLUEPRINT, {
    errorPolicy: "all",
    refetchQueries: [{ query: GET_PERMIT_BLUEPRINTS }],
  });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}

